import type { Answer } from "./types";
import { QUESTION_GROUP_VALUE_PLACEHOLDER } from "./constants";

export const isQuestionGroupHeading = (answer: Answer): boolean =>
  answer.type === "description" && answer.value === QUESTION_GROUP_VALUE_PLACEHOLDER;
